// DESIGN-SPEC §6.2 Reveal 滚动显现
import type { ReactNode } from "react";
import { cn } from "@/lib/cn";

export function Reveal({
  children,
  delay = 0,
  className,
}: {
  children: ReactNode;
  delay?: number;
  className?: string;
}) {
  return (
    <div
      className={cn(className)}
      data-reveal-delay={delay || undefined}
    >
      {children}
    </div>
  );
}
